import { FaCircleDollarToSlot } from "react-icons/fa6";
import IventoryCard from "../../common/helpers/inventory-card";
import { HiUserGroup } from "react-icons/hi2";
import {
  FaCarCrash,
  FaLaptopCode,
  FaMotorcycle,
  FaPeopleArrows,
} from "react-icons/fa";
import { BsFillPersonXFill, BsRocketTakeoffFill } from "react-icons/bs";
import { AiFillAlert, AiFillTool } from "react-icons/ai";
import {
  MdCurrencyExchange,
  MdOutlineApartment,
  MdOutlineCancelPresentation,
} from "react-icons/md";
import { TbCarCrane } from "react-icons/tb";
import { GrDocumentMissing } from "react-icons/gr";
import { GoAlertFill } from "react-icons/go";

export type TutorialItem = {
  key: string;
  title: string;
  icon: React.ReactNode;
  driveLink?: string;
  embedMode?: "grid" | "list";
  legend: string;
  resources?: TutorialResource[];
};

export type TutorialResource = {
  id: string;
  title: string;
  fileId?: string;
  driveFileLink?: string;
  type: "video" | "image" | "document";
  description?: string;
};

// eslint-disable-next-line react-refresh/only-export-components
export const tutorialCatalog: TutorialItem[] = [
  {
    key: "comercial",
    title: "Comercial",
    icon: <HiUserGroup />,
    driveLink: "https://drive.google.com/drive/folders/1zN5B1P6WsFPfOcb3-d5_eu8um8pBs2ya",
    embedMode: "list",
    legend: "Fluxos de atendimento, oferta e condução comercial.",
  },
  {
    key: "embaixador",
    title: "Embaixador",
    icon: <FaPeopleArrows />,
    driveLink: "https://drive.google.com/drive/folders/1yjsfy61rQf2M-h2NymK85yWs-dUj-nHf",
    embedMode: "list",
    legend: "Materiais voltados ao processo e rotina de embaixadores.",
  },
  {
    key: "tech",
    title: "Tech",
    icon: <FaLaptopCode />,
    driveLink: "https://drive.google.com/drive/folders/1zA_6EueGK9kTy9LMH3Q6rBF-21fdxUAI",
    embedMode: "list",
    legend: "Suporte interno, ferramentas e fluxos técnicos.",
  },
  {
    key: "marketing",
    title: "Marketing",
    icon: <BsRocketTakeoffFill />,
    driveLink: "https://drive.google.com/drive/folders/1sy17LLaBLBvY8pRBSFaRUxi5SMX0ZfAe",
    embedMode: "list",
    legend: "Campanhas, comunicação e materiais de marca.",
  },
  {
    key: "problemas-com-gov",
    title: "Problemas com GOV",
    icon: <GoAlertFill />,
    driveLink: "https://drive.google.com/drive/folders/17dKXZLhFdZTakAQYKwgq5js5h2CC-5UZ",
    embedMode: "list",
    legend: "Tratativas para dificuldades com autenticação e GOV.",
  },
  {
    key: "cadastro-gov",
    title: "Cadastrar cliente no Gov",
    icon: <AiFillAlert />,
    driveLink: "https://drive.google.com/drive/folders/11i3a9IKAyJoTUWeNH10dmUviZ1UOYRd0",
    embedMode: "list",
    legend: "Passo a passo para cadastro e apoio ao cliente.",
  },
  {
    key: "cancelamento",
    title: "Cancelamento",
    icon: <MdOutlineCancelPresentation />,
    driveLink: "https://drive.google.com/drive/folders/10-AVDuLkCqZ6QCDnUx7UjupxuHFaiYRq",
    embedMode: "list",
    legend: "Fluxo de cancelamento e orientacoes operacionais.",
  },
  {
    key: "manutencao",
    title: "Manutencao",
    icon: <AiFillTool />,
    driveLink: "https://drive.google.com/drive/folders/1pNiogxgTJarIJ-0z2LubKHyhTjMcdwJ1",
    embedMode: "list",
    legend: "Rotina de triagem, manutencao e fechamento.",
  },
  {
    key: "sinistro",
    title: "Sinistro",
    icon: <FaCarCrash />,
    driveLink: "https://drive.google.com/drive/folders/1UHHZCshULfe6ladKSVRTuFiCnRubGOWu",
    embedMode: "list",
    legend: "Abertura, tratamento e acompanhamento de sinistros.",
  },
  {
    key: "parcerias",
    title: "Parcerias",
    icon: <MdOutlineApartment />,
    driveLink: "https://drive.google.com/drive/folders/1SPDSNcz_TWS8YJYbZcm1y6L8EKvuvclw",
    embedMode: "list",
    legend: "Conteudos para relacionamento e operacao com parceiros.",
  },
  {
    key: "suporte-rua",
    title: "Suporte de Rua",
    icon: <TbCarCrane />,
    driveLink: "https://drive.google.com/drive/folders/1Lb5Pc6IUu7-6WCP3Jw0SPxrWyNcR2E3P",
    embedMode: "list",
    legend: "Guias de atendimento em campo e suporte operacional.",
  },
  {
    key: "recolhimento",
    title: "Recolhimento",
    icon: <BsFillPersonXFill />,
    driveLink: "https://drive.google.com/drive/folders/1AffV-vz40653klueYaFRVc0H9lxD4wFG",
    embedMode: "list",
    legend: "Procedimentos de recolhimento e tratativas associadas.",
  },
  {
    key: "financeiro",
    title: "Financeiro",
    icon: <FaCircleDollarToSlot />,
    driveLink: "https://drive.google.com/drive/folders/1B4V38pSDobKU6nxQrS4dPh3ckoJ4U40k",
    embedMode: "list",
    legend: "Cobrança, pendencias e operacoes financeiras.",
  },
  {
    key: "renegociacao",
    title: "Renegociacao",
    icon: <MdCurrencyExchange />,
    driveLink: "https://drive.google.com/drive/folders/19M74VTHBmoN3sfvgpO-fcsjVbMA6ELoO",
    embedMode: "list",
    legend: "Apoio para renegociacao e conversa com cliente.",
  },
  {
    key: "preparacao",
    title: "Preparacao",
    icon: <FaMotorcycle />,
    driveLink: "https://drive.google.com/drive/folders/1Wi39ylbWSYlPlFrppHqFW4AdZ8C5tqQh",
    embedMode: "list",
    legend: "Checklists e rotinas de preparacao do veiculo.",
  },
  {
    key: "finalizacao-contrato",
    title: "Finalizacao de contrato",
    icon: <GrDocumentMissing />,
    driveLink: "https://drive.google.com/drive/folders/1DfVHxoAFlBTI0APLAKuAoyU0MAao1yDH",
    embedMode: "list",
    legend: "Encerramento de contrato e conferencias finais.",
  },
];

type CardsTutorialProps = {
  selectedKey?: string;
  onSelect: (tutorial: TutorialItem) => void;
};

export function CardsTutorial({
  selectedKey,
  onSelect,
}: CardsTutorialProps) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-1">
      {tutorialCatalog.map((tutorial) => {
        const isSelected = tutorial.key === selectedKey;

        return (
          <button
            key={tutorial.key}
            type="button"
            onClick={() => onSelect(tutorial)}
            className={`text-left transition-transform ${isSelected ? "scale-[1.01]" : ""
              }`}
          >
            <IventoryCard
              icon={tutorial.icon}
              iconSize="48px"
              title={tutorial.title}
              legend={tutorial.legend}
              divClassName={`min-h-[180px] justify-start border px-3 pb-4 pt-5 ${isSelected
                ? "border-redPrimary bg-redPrimary/10 shadow-xl"
                : "border-gray/20 bg-white hover:border-redPrimary/50"
                }`}
              className={isSelected ? "text-redPrimary" : undefined}
              iconClassName={isSelected ? "text-redPrimary" : "text-gray3"}
              titleClassName={`text-lg leading-tight sm:text-xl ${isSelected ? "text-redPrimary" : "text-gray3"
                }`}
              legendClassName="px-1 text-xs leading-5 sm:text-sm"
            />
          </button>
        );
      })}
    </div>
  );
}
